/**
 * The MIT License (MIT)
 * Copyright (c) 2017-present Dmitry Soshnikov <dmitry.soshnikov@gmail.com>
 */
'use strict';

module.exports = [// a+ -> aa*
require('./char-plus-to-star-transform')];